import client from './client'

export default {
  allCategories () {
    return client.withAuth().get('womapi/api/home/categories')
  }
}
